import {z} from '@hono/zod-openapi';

export const vehicleMappingConfigurationStatusSchema = z.enum([
  'staged',
  'active',
  'superseded',
  'rejected',
]);
